import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { About_url, Contact_url, Privacy_url } from "../../constants";
import styles from "./style.module.css";

const Menus = () => {
  const [activeItem, setActiveItem] = useState();
  const collapseRef = useRef(null);

  useEffect(() => {
    const href = window.location.href.substring(
      window.location.href.lastIndexOf("#") + 1
    );
    console.log("href", href);

    const element = document.getElementById(href);
    console.log("href element", element);

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, [activeItem]);

  const menus = [
    {
      id: 1,
      name: "Home",
      link: "/",
      isBold: "bold",
    },
    {
      id: 2,
      name: "Find a Teacher",
      link: "/search?query=&gender=&modeOfTeaching=&cityId=&areaId=&course-level=&qualification-level=&education-board=",
      isBold: "",
    },
    // {
    //   id: 3,
    //   name: "Become a Teacher",
    //   link: "",
    //   isBold: "",
    // },
    {
      id: 3,
      name: "Blog",
      link: "/#BlogArticles",
      isBold: "",
    },
    // {
    //   id: 4,
    //   name: "Free Learnding",
    //   link: "",
    //   isBold: "",
    // },
    // {
    //   id: 5,
    //   name: "Scholerships",
    //   link: "",
    //   isBold: "",
    // },
    // {
    //   id: 6,
    //   name: "Community Service",
    //   link: "",
    //   isBold: "",
    // },
    // {
    //   id: 7,
    //   name: "Advertise With Us",
    //   link: "",
    //   isBold: "",
    // },
    // {
    //   id: 8,
    //   name: "Invertor Relation",
    //   link: "",
    //   isBold: "",
    // },
    // {
    //   id: 9,
    //   name: "Merchendise",
    //   link: "",
    //   isBold: "",
    // },
    // {
    //   id: 10,
    //   name: "Blogs",
    //   link: "",
    //   isBold: "",
    // },
    // {
    //   id: 11,
    //   name: "Privacy Policy",
    //   link: Privacy_url,
    //   isBold: "",
    // },
    {
      id: 12,
      name: "Contact Us",
      link: Contact_url,
      isBold: "",
    },
    {
      id: 13,
      name: "About Us",
      link: About_url,
      isBold: "",
    },
  ];

  const handleItemClick = (itemId) => {
    setActiveItem(itemId);
    // Programmatically close the mobile menu
    if (collapseRef.current) {
      collapseRef.current.classList.remove("show");
    }
  };
  return (
    <>
      {menus?.map((item) => {
        return (
          <li
            key={item?.id}
            className={`nav-item ${styles?.customFont}`}
            onClick={() => handleItemClick(item.id)}
          >
            <Link
              className={`nav-link text-black ${
                activeItem === item.id ? "fw-bold" : ""
              }`}
              aria-current="page"
              to={item?.link}
            >
              {item?.name}
            </Link>
          </li>
        );
      })}
    </>
  );
};

export default Menus;
